
import {serializable, alias, object, list, primitive} from 'serializr';

export class MostLikedContentModel { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('like', primitive()))
	likes?: number;

	@serializable(alias('dislIke', primitive()))
	dislikes?: number;

	@serializable(alias('contentLength', primitive()))
	contentLength?: number;

	@serializable(alias('attempts', primitive()))
	attempts?: number;

	@serializable(alias('className', primitive()))
	classRoom?: string;

	@serializable(alias('boardName', primitive()))
	board?: string;

	@serializable(alias('subjectName', primitive()))
	subject?: string;

	@serializable(alias('chapterName', primitive()))
	chapter?: string;

	@serializable(alias('no_of_question', primitive()))
	noOfQuestion?: number;

	@serializable(alias('contentName', primitive()))
	contentName?: string;

	@serializable(alias('contentThumbnail', primitive()))
	contentThumbUrl?: string;

	@serializable(alias('contentType', primitive()))
	contentType?: "external_link" | "video" | "pdf";
}